import * as Sentry from '@sentry/react';

const DSN = import.meta.env.VITE_SENTRY_DSN ?? '';

export const initErrorMonitoring = (): void => {
  if (!DSN || import.meta.env.DEV) return;

  Sentry.init({
    dsn: DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
    release: import.meta.env.VITE_GIT_SHA || undefined,
    sendDefaultPii: false,
    tracesSampleRate: 0.05,
    integrations: (defaults) => defaults.filter((integration) => integration.name !== 'GlobalHandlers'),
    beforeSend: (event) => {
      event.user = undefined;
      if (event.request) {
        event.request.cookies = undefined;
        event.request.data = undefined;
        event.request.headers = undefined;
        event.request.query_string = undefined;
      }
      return event;
    },
  });
};

export const captureClientException = (error: Error): void => {
  if (!DSN || import.meta.env.DEV) return;
  Sentry.captureException(error);
};
